import { Evnt } from '../__types';

const events: Evnt[] = [
  {
    id: 'hobbiton-3018-04-12',
    location: 'hobbiton',
    date: new Date('3018-04-12'),
    title: 'Gandalf reaches Hobbiton and tells Frodo about the ring.',
    participants: ['gandalf', 'frodoSam'],
  },
  {
    id: 'hobbiton-3018-06-30',
    location: 'hobbiton',
    date: new Date('3018-06-30'),
    title: 'Gandalf leaves Hobbiton.',
    participants: ['gandalf'],
    paths: {
      gandalf: `M 1776.00,1345.00
      C 1799.00,1400.00 1799.00,1395.00 1834.00,1419.00
        1869.00,1443.00 1898.00,1479.00 1906.00,1510.00
        1914.00,1541.00 1941.00,1548.00 1961.00,1563.00
        1981.00,1578.00 2018.00,1588.00 2058.00,1589.00
        2098.00,1590.00 2188.00,1617.00 2197.00,1620.00
        2206.00,1623.00 2244.00,1625.00 2263.00,1644.00
        2282.00,1663.00 2327.00,1685.00 2338.00,1690.00
        2349.00,1695.00 2417.00,1727.00 2462.00,1819.00
        2507.00,1911.00 2507.00,1923.00 2525.00,1948.00
        2543.00,1973.00 2558.00,1986.00 2584.00,2095.00
        2610.00,2204.00 2645.00,2283.00 2650.00,2322.00
        2655.00,2361.00 2785.00,2506.00 2953.00,2552.00`,
    },
  },
  {
    id: 'isengard-3018-07-20',
    location: 'isengard',
    date: new Date('3018-07-20'),
    title: 'Gandalf imprisoned in Orthanc.',
    participants: ['gandalf'],
  },
  {
    id: 'isengard-3018-09-18',
    location: 'isengard',
    date: new Date('3018-09-18'),
    title: 'Gandalf escapes from Orthanc.',
    participants: ['gandalf'],
    paths: {
      gandalf: `M 2960.00,2556.00
      C 2996.00,2601.00 3089.00,2690.00 3132.00,2722.00
        3175.00,2754.00 3249.00,2818.00 3261.00,2846.00
        3273.00,2874.00 3286.00,2930.00 3287.00,2943.00`,
    },
  },
  {
    id: 'edoras-3018-09-19',
    location: 'edoras',
    date: new Date('3018-09-19'),
    title: 'Gandalf comes to Edoras.',
    participants: ['gandalf'],
  },
  {
    id: 'edoras-3018-09-23',
    location: 'edoras',
    date: new Date('3018-09-23'),
    title: 'Gandalf tames Shadowfax and departs for Hobbiton.',
    participants: ['gandalf'],
    paths: {
      gandalf: `M 3288.00,2935.00
      C 3245.00,2899.00 3159.00,2836.00 3135.00,2808.00
        3111.00,2780.00 3039.00,2759.00 3034.00,2756.00
        3029.00,2753.00 3021.00,2718.00 3008.00,2711.00
        2995.00,2704.00 2953.00,2694.00 2862.00,2703.00
        2771.00,2712.00 2754.00,2616.00 2734.00,2577.00
        2714.00,2538.00 2690.00,2437.00 2677.00,2378.00
        2664.00,2319.00 2606.00,2114.00 2606.00,2114.00
        2606.00,2114.00 2572.00,1980.00 2547.00,1953.00
        2522.00,1926.00 2463.00,1780.00 2427.00,1748.00
        2391.00,1716.00 2363.00,1696.00 2312.00,1669.00
        2261.00,1642.00 2228.00,1620.00 2135.00,1602.00
        2042.00,1584.00 1999.00,1599.00 1967.00,1569.00
        1935.00,1539.00 1917.00,1526.00 1909.00,1504.00
        1901.00,1482.00 1870.00,1435.00 1828.00,1414.00
        1786.00,1393.00 1764.00,1344.00 1835.00,1326.00`,
    },
  },
  {
    id: 'hobbiton-3018-09-29',
    location: 'hobbiton',
    date: new Date('3018-09-29'),
    title: 'Gandalf reaches Hobbiton. Talks to Gaffer.',
    participants: ['gandalf'],
    paths: {
      gandalf: `M 1845.00,1328.00
      C 1899.00,1331.00 1909.00,1333.00 1963.00,1312.00
        2017.00,1291.00 2085.00,1284.00 2140.00,1286.00
        2195.00,1288.00 2215.00,1290.00 2229.00,1319.00
        2243.00,1348.00 2253.00,1351.00 2262.00,1349.00`,
    },
  },
  {
    id: 'bree-3018-10-01',
    location: 'bree',
    date: new Date('3018-10-01'),
    title: 'Gandalf leaves Bree.',
    participants: ['gandalf'],
    paths: {
      gandalf: `M 2264.00,1342.00
      C 2337.00,1332.00 2370.00,1332.00 2423.00,1337.00
        2476.00,1342.00 2495.00,1307.00 2551.00,1298.00`,
    },
  },
  {
    id: 'weathertop-3018-10-03',
    location: 'weathertop',
    date: new Date('3018-10-03'),
    title: 'Gandalf is attacked at Weathertop.',
    participants: ['gandalf'],
    paths: {
      gandalf: `M 2556.00,1290.00
      C 2631.00,1264.00 2709.00,1237.00 2745.00,1238.00
        2781.00,1239.00 2846.00,1285.00 2883.00,1282.00
        2920.00,1279.00 2916.00,1225.00 2985.00,1220.00
        3054.00,1215.00 3115.00,1228.00 3140.00,1238.00
        3165.00,1248.00 3209.00,1288.00 3229.00,1291.00`,
    },
  },
  {
    id: 'rivendell-3018-10-18',
    location: 'rivendell',
    date: new Date('3018-10-18'),
    title: 'Gandalf reaches Rivendell.',
    participants: ['gandalf'],
  },
  {
    id: 'rivendell-3018-10-25',
    location: 'rivendell',
    date: new Date('3018-10-25'),
    title: 'The Council of Elrond.',
    // eslint-disable-next-line prettier/prettier
    participants: ['gandalf', 'frodoSam', 'aragorn', 'boromir', 'legolasGimli'],
  },
  {
    id: 'hobbiton-3018-09-22',
    location: 'hobbiton',
    date: new Date('3018-09-22'),
    title: "Frodo's birthday Party.",
    participants: ['frodoSam', 'merryPippin'],
  },
  {
    id: 'hobbiton-3018-09-23',
    location: 'hobbiton',
    date: new Date('3018-09-23'),
    title: 'The hobbits leave Hobbiton.',
    participants: ['frodoSam', 'merryPippin'],
    paths: {
      frodoSam: `M 1839.00,1323.00
      C 1871.00,1366.00 1886.00,1420.00 1912.00,1413.00`,
      merryPippin: `M 1849.00,1325.00
      C 1874.00,1347.00 1910.00,1355.00 1929.00,1357.00
        1948.00,1359.00 1988.00,1366.00 1993.00,1372.00`,
    },
  },
  {
    id: 'hobbiton-3018-09-24',
    location: 'hobbiton',
    date: new Date('3018-09-24'),
    // eslint-disable-next-line prettier/prettier
    title:
      'Frodo meets and travels with Gildor Inglorion in Green-hill country.',
    participants: ['frodoSam'],
    paths: {
      frodoSam: `M 1924.00,1413.00
      C 1953.00,1400.00 1969.00,1374.00 1991.00,1376.00`,
    },
  },
  {
    id: 'hobbiton-3018-09-25',
    location: 'hobbiton',
    date: new Date('3018-09-25'),
    title: 'The hobbits reunite in Crickhollow.',
    participants: ['frodoSam', 'merryPippin'],
    paths: {
      frodoSam: `M 2000.00,1376.00
      C 2034.00,1362.00 2043.00,1371.00 2058.00,1385.00
        2073.00,1399.00 2103.00,1402.00 2114.00,1400.00`,
      merryPippin: `M 2000.00,1376.00
      C 2034.00,1362.00 2043.00,1371.00 2058.00,1385.00
        2073.00,1399.00 2103.00,1402.00 2114.00,1400.00`,
    },
  },
  {
    id: 'oldForest-3018-09-26',
    location: 'oldForest',
    date: new Date('3018-09-26'),
    title: 'The hobbits enter Old Forest and find Tom Bombadil.',
    participants: ['frodoSam', 'merryPippin'],
    paths: {
      frodoSam: `M 2130.00,1404.00
      C 2163.00,1403.00 2179.00,1418.00 2199.00,1408.00`,
      merryPippin: `M 2130.00,1404.00
      C 2163.00,1403.00 2179.00,1418.00 2199.00,1408.00`,
    },
  },
  {
    id: 'oldForest-3018-09-28',
    location: 'oldForest',
    date: new Date('3018-09-28'),
    title: 'The hobbits are captured by a Barrow-wight.',
    participants: ['frodoSam', 'merryPippin'],
    paths: {
      frodoSam: `M 2218.00,1399.00
      C 2237.00,1375.00 2239.00,1362.00 2262.00,1354.00`,
      merryPippin: `M 2218.00,1399.00
      C 2237.00,1375.00 2239.00,1362.00 2262.00,1354.00`,
    },
  },
  {
    id: 'bree-3018-09-29',
    location: 'bree',
    date: new Date('3018-09-29'),
    title: 'The hobbits arrive at Bree at nightfall and meet the Strider.',
    participants: ['frodoSam', 'merryPippin', 'aragorn'],
  },
  {
    id: 'bree-3018-09-30',
    location: 'bree',
    date: new Date('3018-09-30'),
    title: 'Aragorn leaves Bree with Frodo and company.',
    participants: ['frodoSam', 'merryPippin', 'aragorn'],
    paths: {
      frodoSam: `M 2265.00,1347.00
      C 2295.00,1309.00 2348.00,1259.00 2404.00,1266.00
        2460.00,1273.00 2512.00,1300.00 2552.00,1303.00`,
      aragorn: `M 2265.00,1347.00
      C 2295.00,1309.00 2348.00,1259.00 2404.00,1266.00
        2460.00,1273.00 2512.00,1300.00 2552.00,1303.00`,
      merryPippin: `M 2265.00,1347.00
      C 2295.00,1309.00 2348.00,1259.00 2404.00,1266.00
        2460.00,1273.00 2512.00,1300.00 2552.00,1303.00`,
    },
  },
  {
    id: 'weathertop-3018-10-06',
    location: 'weathertop',
    date: new Date('3018-10-06'),
    title: 'Night at Weathertop.',
    participants: ['frodoSam', 'merryPippin', 'aragorn'],
    paths: {
      frodoSam: `M 2559.00,1310.00
      C 2608.00,1319.00 2633.00,1390.00 2682.00,1370.00
        2731.00,1350.00 2825.00,1271.00 2890.00,1288.00`,
      aragorn: `M 2559.00,1310.00
      C 2608.00,1319.00 2633.00,1390.00 2682.00,1370.00
        2731.00,1350.00 2825.00,1271.00 2890.00,1288.00`,
      merryPippin: `M 2559.00,1310.00
      C 2608.00,1319.00 2633.00,1390.00 2682.00,1370.00
        2731.00,1350.00 2825.00,1271.00 2890.00,1288.00`,
    },
  },
  {
    id: 'lastBridge-3018-10-13',
    location: 'lastBridge',
    date: new Date('3018-10-13'),
    title: 'Aragorn and hobbits cross bridge at Mitheithel.',
    participants: ['frodoSam', 'merryPippin', 'aragorn'],
    paths: {
      frodoSam: `M 2887.00,1296.00
      C 2929.00,1302.00 2974.00,1291.00 2995.00,1282.00`,
      merryPippin: `M 2887.00,1296.00
      C 2929.00,1302.00 2974.00,1291.00 2995.00,1282.00`,
      aragorn: `M 2887.00,1296.00
      C 2929.00,1302.00 2974.00,1291.00 2995.00,1282.00`,
    },
  },
  {
    id: 'trollshaws-3018-10-18',
    location: 'trollshaws',
    date: new Date('3018-10-18'),
    title: 'Glorfindel finds Frodo.',
    participants: ['frodoSam', 'merryPippin', 'aragorn'],
    paths: {
      frodoSam: `M 3013.00,1265.00
      C 3074.00,1275.00 3073.00,1316.00 3128.00,1320.00
        3183.00,1324.00 3170.00,1340.00 3231.00,1294.00`,
      merryPippin: `M 3013.00,1265.00
      C 3074.00,1275.00 3073.00,1316.00 3128.00,1320.00
        3183.00,1324.00 3170.00,1340.00 3231.00,1294.00`,
      aragorn: `M 3013.00,1265.00
      C 3074.00,1275.00 3073.00,1316.00 3128.00,1320.00
        3183.00,1324.00 3170.00,1340.00 3231.00,1294.00`,
    },
  },
  {
    id: 'rivendell-3018-10-20',
    location: 'rivendell',
    date: new Date('3018-10-20'),
    title: 'Frodo arrives at Rivendell.',
    participants: ['frodoSam', 'merryPippin', 'aragorn'],
  },
  {
    id: 'rivendell-3018-10-24',
    location: 'rivendell',
    date: new Date('3018-10-24'),
    title: 'Frodo awakes in Rivendell. Boromir arrives in Rivendell.',
    participants: ['frodoSam', 'boromir'],
  },
  {
    id: 'minasTirith-3018-07-04',
    location: 'minasTirith',
    date: new Date('3018-07-04'),
    title: 'Boromir sets out from Minas Tirith and leaves for Rivendell.',
    participants: ['boromir'],
    paths: {
      boromir: `M 4233.00,3290.00
      C 4202.00,3294.00 4201.00,3298.00 4127.00,3267.00
        4025.00,3224.00 3959.00,3189.00 3850.00,3191.00
        3741.00,3193.00 3622.00,3156.00 3594.00,3140.00
        3566.00,3124.00 3446.00,3073.00 3416.00,3046.00
        3386.00,3019.00 3338.00,2952.00 3302.00,2939.00
        3266.00,2926.00 3177.00,2854.00 3140.00,2810.00
        3103.00,2766.00 3053.00,2771.00 3023.00,2738.00
        2993.00,2705.00 2951.00,2696.00 2860.00,2699.00
        2769.00,2702.00 2713.00,2556.00 2697.00,2505.00
        2681.00,2454.00 2610.00,2203.00 2597.00,2147.00
        2584.00,2091.00 2572.00,2002.00 2536.00,1962.00
        2500.00,1922.00 2499.00,1923.00 2504.00,1910.00
        2509.00,1897.00 2568.00,1828.00 2596.00,1803.00
        2624.00,1778.00 2715.00,1718.00 2771.00,1693.00
        2827.00,1668.00 3003.00,1543.00 3046.00,1501.00
        3089.00,1459.00 3132.00,1424.00 3149.00,1392.00
        3166.00,1360.00 3205.00,1308.00 3226.00,1295.0`,
    },
  },
];

export default events;
